module.exports = __webpack_public_path__ + "static/media/wave2.6cd18bc0.png";